import { MappingItem, Reminder } from "../Models";
import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

export const getReminderByAvailableAppointmentID = async (appointmentId: string) => {
    try {
        const response = await fetch(
            baseUrl + `/api/Reminder/${appointmentId}`,
            {
                headers: {
                    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
                },
            }
        );
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        if (response.status === 204) {
            return [];
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const DeleteReminder = async (id: string) => {
    try {
        const response = await fetch(
            baseUrl + `/api/Reminder/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
                },
                method: 'DELETE'
            }
        );
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.ok;
    } catch (error) {
        console.log(error); // Add this line for debugging
        throw error;
    }
}

export const AddReminder = async (reminder: Reminder[]) => {

    try {
        const response = await fetch(
            baseUrl + `/api/Reminder`,
            {
                headers: {
                    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(reminder)
            }
        );
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.ok;
    } catch (error) {
        console.log(error); // Add this line for debugging
        throw error;
    }
}


export const saveTenantMappings = async (mappings: MappingItem[]) => {
    const response = await fetch(baseUrl+'/api/Reminder/SaveMappings', {
        method: 'POST',
        headers: {
                Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(mappings),
    });
    if (response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
        return;
    }
    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || 'Failed to save mappings');
    }
    return response.json();
};


export const getTenantMappings = async (arhId: string) => {
    const token = await getTokenFromLocalStorage();
    const response = await fetch(`${baseUrl}/api/Reminder/GetMappings/${arhId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });
    if (response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
        return;
    }
    if (response.status === 204 ||response.status === 404) {
        return []; 
    }
    if (!response.ok) {
        throw new Error('Failed to fetch mappings');
    }
    return response.json();
};

export const sendAppfolioMatchEmail = async (arhid: string): Promise<boolean> => {
    const token = await getTokenFromLocalStorage();
    try {
        const response = await fetch( baseUrl+'/api/Showings/SendAppfolioMatchEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                 Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(arhid)
        });
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return false;
        }
        if (response.ok) {
            return true;
        } else {
            console.error('Failed to mark resend value 1', response.statusText);
            return false;
        }
    } catch (error) {
        console.error('failing changing resend value', error);
        return false;
    }
};



